import React from "react";
import styled from "styled-components";
import greekLeerdoelen from "../../data/leerdoelen-grieks";
import latinLeerdoelen from "../../data/leerdoelen-latijn";

const Container = styled.div`
  margin-bottom: 1.9rem;
`;

export default ({ book, leerdoel }) => {
  const leerdoelenList = book == "spqr" ? latinLeerdoelen : greekLeerdoelen;
  const leerdoelDesc = leerdoelenList[leerdoel].description;

  return (
    <Container>
      <h2>Leerdoel</h2>
      <p>{leerdoelDesc}</p>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/leerdoel/Leerdoel.js